/**
 * 多账号标签
 */
export var MULTI_LOGIN_TIP;
(function (MULTI_LOGIN_TIP) {
    MULTI_LOGIN_TIP["none"] = "";
    MULTI_LOGIN_TIP["login"] = "login";
})(MULTI_LOGIN_TIP || (MULTI_LOGIN_TIP = {}));
/**
 * 是否请求checkKey flag
 */
export var REQUEST_CHECK_KEY_FLAG;
(function (REQUEST_CHECK_KEY_FLAG) {
    REQUEST_CHECK_KEY_FLAG[REQUEST_CHECK_KEY_FLAG["none"] = 0] = "none";
    REQUEST_CHECK_KEY_FLAG[REQUEST_CHECK_KEY_FLAG["request"] = 1] = "request";
})(REQUEST_CHECK_KEY_FLAG || (REQUEST_CHECK_KEY_FLAG = {}));
/**
 * 控制获取 URL 的类型
 */
export var IWechatLoginCase;
(function (IWechatLoginCase) {
    // 获取 公众号 URL
    IWechatLoginCase[IWechatLoginCase["WECHAT_LOGIN_CASE_DEFAULT"] = 0] = "WECHAT_LOGIN_CASE_DEFAULT";
    // 获取 H5登录页面 URL
    IWechatLoginCase[IWechatLoginCase["WECHAT_LOGIN_CASE_H5"] = 1] = "WECHAT_LOGIN_CASE_H5";
})(IWechatLoginCase || (IWechatLoginCase = {}));
